<template>
    <div>
        <b-alert show>
            <span>
                Item de Contrato:
                <strong
                    >{{ itemContrato.ordem }} -
                    {{ itemContrato.descricao }}</strong
                >
                <br />Valor:
                <strong>{{ itemContrato.valorUnitario | currency }}</strong>
                <br />Saldo:
                <strong>{{ itemContrato.saldoValor | currency }}</strong>
                <br />Seq RM:
                <strong>{{ itemContrato.seqRM }}</strong>
                <br />Status:
                <app-status
                    :status="itemContrato.status == 1 ? 'ATIVO' : 'INATIVO'"
                ></app-status>
            </span>
        </b-alert>
        <div class="d-flex flex-row-reverse mb-3">
            <b-button variant="danger" @click.stop="voltar()">
                <span>
                    <i class="fa fa-history mr-2"></i> Retornar para os Itens
                </span>
            </b-button>
        </div>
        <app-tabela
            :itens="subItens"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="botoes"></template>
            <template slot="valorUnitario" slot-scope="data">
                <p class="text-right m-0">
                    {{ data.valorUnitario | currency }}
                </p>
            </template>
            <template slot="status" slot-scope="data">
                <app-status
                    :status="data.status == 1 ? 'ATIVO' : 'INATIVO'"
                ></app-status>
            </template>
            <template slot="saldoQtd" slot-scope="data">
                <span v-if="data.quantidade > 0">{{ data.saldoQtd }}</span>
                <span v-if="data.quantidade == 0">N/A</span>
            </template>
        </app-tabela>
    </div>
</template>

<script>
export default {
    props: {
        itemContrato: {
            type: Object,
            default: () => {}
        },

        contrato: {
            type: Object,
            default: () => {}
        },

        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
            subItens: [],
            campos: [
                {
                    key: 'ordem',
                    label: 'Nº',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descricaoResumida',
                    label: 'Descrição Resumida',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'quantidade',
                    label: 'Qtd',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'seqRM',
                    label: 'Seq RM',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'saldoQtd',
                    label: 'Saldo Qtd',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    tdClass: 'text-center'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        voltar() {
            this.$emit('fecharSubItens')
        },

        obterSubItens() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .obterSubItens(
                    this.$route.params.contratoId,
                    this.itemContrato.itemContratoId
                )
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.subItens = response.data
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    created() {
        this.obterSubItens()
    }
}
</script>
